import Model, { attr, belongsTo } from '@ember-data/model';

export default class ClinicianDocumentReviewModel extends Model {
  @belongsTo('team-member', { async: false }) reviewedByUser;
  @belongsTo('treatable-client', { polymorphic: true, async: false }) client;
  @belongsTo('practice', { async: false }) practice;

  @attr('string') status;
  @attr('moment') createdAt;
  @attr('moment') updatedAt;
}
